import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{staticClass:"mt-10 pa-10 d-flex flex-column align-center justify-center transparent",attrs:{"flat":""}},[_c(VImg,{attrs:{"src":_vm.imagePath,"max-height":"400","contain":""}}),_c('span',{staticClass:"display-1 font-weight-light text--disabled"},[_vm._v("Let's search")]),_c('span',{staticClass:"body-1 font-weight-light text--secondary mt-1"},[_vm._v("Please enter something to start your search in Better Call Dev")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }